import { ACTION } from '@cvent/react-analytics';

export const changeAttendeeVisibility = {
  id: 'event_app_change_attendee_visibility',
  name: 'Change attendee visibility',
  type: ACTION,
  destinations: ['Mixpanel', 'Analytics', 'AttendeeActivities'],
  attributes: ['visibility', 'previousVisibility', 'factOrigin'],
  objectIdAttribute: 'attendeeId',
  activityType: 'attendee.change_visibility'
};

export const editAttendeeProfile = {
  id: 'event_app_edit_attendee_profile',
  name: 'Edit attendee profile',
  type: ACTION,
  destinations: ['Mixpanel', 'Analytics', 'AttendeeActivities'],
  attributes: ['section', 'visibility'],
  objectIdAttribute: 'attendeeId',
  activityType: 'attendee.edit_profile'
};
